import { component } from 'picoapp';
import SwiperClass from 'swiper/types/swiper-class';
import { SwiperOptions } from 'swiper/types/swiper-options';

export default component(async (node) => {
  const slider: HTMLElement = node.querySelector('[data-slider]');

  const breakpoint = window.matchMedia('(max-width: 1023px)');

  let swiperSlider: SwiperClass;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(async (entry) => {
      if (entry.isIntersecting) {
        const Swiper = (await import(
          /* webpackChunkName: "swiper" */
          'modules/swiper'
        )).default;

        swiperSlider = new Swiper(slider, {
          slidesPerView: 'auto',
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
        } as SwiperOptions);

        swiperSlider.init();

        observer.disconnect();
      }
    });
  });

  const checker = () => {
    if (breakpoint.matches) observer.observe(node);
    else swiperSlider?.destroy?.();
  };

  checker();
  breakpoint.addEventListener('change', checker);
});
